import { Link } from "react-router";
import { Icon } from "@/components/icons";
import { VARIANTS } from "./_data/variants";

export default function MatchDetailIndexPage() {
  return (
    <div className="flex flex-1 flex-col gap-6 bg-white p-8">
      <header className="flex flex-col gap-1">
        <span className="text-tiny font-medium uppercase tracking-wide text-grey-500">Preview</span>
        <h1 className="text-h2 text-black">Match-detail variants</h1>
        <p className="max-w-[560px] text-small text-grey-900">
          The same match-detail layout (header icon · name · source chip · 3 cards · tabs) populated
          with mock data for each record type.
        </p>
      </header>

      <ul className="grid grid-cols-1 gap-2 md:grid-cols-2 xl:grid-cols-3">
        <li>
          <PreviewCard
            href="/screening?q=putin"
            icon="person"
            label="Person — Sanctions"
            sublabel="Already in production · click a row"
            badge="UK-SANCTIONS"
          />
        </li>
        {VARIANTS.map((v) => (
          <li key={v.slug}>
            <PreviewCard
              href={`/preview/match-detail/${v.slug}`}
              icon={v.headerIcon}
              label={v.label}
              sublabel={v.name}
              badge={v.source}
            />
          </li>
        ))}
      </ul>
    </div>
  );
}

function PreviewCard({
  href,
  icon,
  label,
  sublabel,
  badge,
}: {
  href: string;
  icon: string;
  label: string;
  sublabel: string;
  badge: string;
}) {
  return (
    <Link
      to={href}
      className="flex h-full items-center gap-3 rounded-[4px] border border-grey-200 bg-white p-4 shadow-flat transition-colors hover:bg-grey-50"
    >
      <div className="flex size-10 shrink-0 items-center justify-center rounded-[4px] bg-grey-100 text-grey-900">
        <Icon name={icon} size={24} />
      </div>
      <div className="flex min-w-0 flex-1 flex-col gap-0.5">
        <span className="text-body font-semibold text-black">{label}</span>
        <span className="truncate text-small text-grey-900">{sublabel}</span>
      </div>
      <span className="inline-flex shrink-0 items-center gap-1 rounded-[4px] bg-grey-200 px-2 py-1 text-small font-medium text-grey-900">
        {badge}
      </span>
    </Link>
  );
}
